var _rect, _rect2, _rect3, _rect4, _rect5, _path, _g, _rect6, _path2, _rect7, _path3, _rect8, _path4, _circle, _path5, _circle2, _path6, _circle3, _path7, _circle4, _path8, _rect9, _rect10, _rect11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageLayoutSocialAndCtaReach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 302,
    viewBox: "0 0 384 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 302,
    fill: "#272A32"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 61,
    width: 96,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 69,
    width: 96,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 77,
    width: 72,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 103,
    width: 208,
    height: 108,
    rx: 6,
    fill: "white",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8516_255934",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 148,
    width: 15,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.57 150.093V163.906C132.57 164.96 133.73 165.6 134.624 165.026L145.477 158.12C146.304 157.6 146.304 156.4 145.477 155.866L134.624 148.973C133.73 148.4 132.57 149.04 132.57 150.093Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8516_255934)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 141,
    width: 32,
    height: 32,
    fill: "white",
    fillOpacity: 0.8
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 113,
    width: 102,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.189 126.816C302.037 127.328 301.797 127.756 301.469 128.1C301.141 128.444 300.753 128.7 300.305 128.868C299.857 129.036 299.365 129.12 298.829 129.12C298.045 129.12 297.365 128.956 296.789 128.628C296.221 128.3 295.781 127.832 295.469 127.224C295.165 126.616 295.013 125.888 295.013 125.04C295.013 124.192 295.165 123.464 295.469 122.856C295.781 122.248 296.221 121.78 296.789 121.452C297.365 121.124 298.037 120.96 298.805 120.96C299.349 120.96 299.841 121.036 300.281 121.188C300.721 121.332 301.093 121.556 301.397 121.86C301.709 122.164 301.937 122.548 302.081 123.012L300.581 123.648C300.445 123.168 300.237 122.828 299.957 122.628C299.677 122.42 299.317 122.316 298.877 122.316C298.445 122.316 298.065 122.42 297.737 122.628C297.417 122.836 297.169 123.144 296.993 123.552C296.817 123.952 296.729 124.448 296.729 125.04C296.729 125.624 296.809 126.12 296.969 126.528C297.137 126.936 297.381 127.244 297.701 127.452C298.021 127.66 298.413 127.764 298.877 127.764C299.309 127.764 299.681 127.648 299.993 127.416C300.313 127.184 300.537 126.832 300.665 126.36L302.189 126.816ZM309.864 121.08V122.412H307.212V129H305.556V122.412H302.892V121.08H309.864ZM317.074 129H315.358L314.698 127.068H311.662L311.002 129H309.31L312.202 121.08H314.182L317.074 129ZM312.034 125.844H314.326L313.174 122.388L312.034 125.844Z",
    fill: "white",
    fillOpacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 145,
    width: 102,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.189 158.816C302.037 159.328 301.797 159.756 301.469 160.1C301.141 160.444 300.753 160.7 300.305 160.868C299.857 161.036 299.365 161.12 298.829 161.12C298.045 161.12 297.365 160.956 296.789 160.628C296.221 160.3 295.781 159.832 295.469 159.224C295.165 158.616 295.013 157.888 295.013 157.04C295.013 156.192 295.165 155.464 295.469 154.856C295.781 154.248 296.221 153.78 296.789 153.452C297.365 153.124 298.037 152.96 298.805 152.96C299.349 152.96 299.841 153.036 300.281 153.188C300.721 153.332 301.093 153.556 301.397 153.86C301.709 154.164 301.937 154.548 302.081 155.012L300.581 155.648C300.445 155.168 300.237 154.828 299.957 154.628C299.677 154.42 299.317 154.316 298.877 154.316C298.445 154.316 298.065 154.42 297.737 154.628C297.417 154.836 297.169 155.144 296.993 155.552C296.817 155.952 296.729 156.448 296.729 157.04C296.729 157.624 296.809 158.12 296.969 158.528C297.137 158.936 297.381 159.244 297.701 159.452C298.021 159.66 298.413 159.764 298.877 159.764C299.309 159.764 299.681 159.648 299.993 159.416C300.313 159.184 300.537 158.832 300.665 158.36L302.189 158.816ZM309.864 153.08V154.412H307.212V161H305.556V154.412H302.892V153.08H309.864ZM317.074 161H315.358L314.698 159.068H311.662L311.002 161H309.31L312.202 153.08H314.182L317.074 161ZM312.034 157.844H314.326L313.174 154.388L312.034 157.844Z",
    fill: "white",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 177,
    width: 102,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.189 190.816C302.037 191.328 301.797 191.756 301.469 192.1C301.141 192.444 300.753 192.7 300.305 192.868C299.857 193.036 299.365 193.12 298.829 193.12C298.045 193.12 297.365 192.956 296.789 192.628C296.221 192.3 295.781 191.832 295.469 191.224C295.165 190.616 295.013 189.888 295.013 189.04C295.013 188.192 295.165 187.464 295.469 186.856C295.781 186.248 296.221 185.78 296.789 185.452C297.365 185.124 298.037 184.96 298.805 184.96C299.349 184.96 299.841 185.036 300.281 185.188C300.721 185.332 301.093 185.556 301.397 185.86C301.709 186.164 301.937 186.548 302.081 187.012L300.581 187.648C300.445 187.168 300.237 186.828 299.957 186.628C299.677 186.42 299.317 186.316 298.877 186.316C298.445 186.316 298.065 186.42 297.737 186.628C297.417 186.836 297.169 187.144 296.993 187.552C296.817 187.952 296.729 188.448 296.729 189.04C296.729 189.624 296.809 190.12 296.969 190.528C297.137 190.936 297.381 191.244 297.701 191.452C298.021 191.66 298.413 191.764 298.877 191.764C299.309 191.764 299.681 191.648 299.993 191.416C300.313 191.184 300.537 190.832 300.665 190.36L302.189 190.816ZM309.864 185.08V186.412H307.212V193H305.556V186.412H302.892V185.08H309.864ZM317.074 193H315.358L314.698 191.068H311.662L311.002 193H309.31L312.202 185.08H314.182L317.074 193ZM312.034 189.844H314.326L313.174 186.388L312.034 189.844Z",
    fill: "white",
    fillOpacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 327,
    cy: 71,
    r: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327 66C325.642 66 325.472 66.0062 324.939 66.03C324.406 66.055 324.044 66.1388 323.725 66.2625C323.396 66.39 323.117 66.5612 322.839 66.8392C322.561 67.1171 322.39 67.3958 322.262 67.725C322.139 68.0437 322.055 68.4062 322.03 68.9388C322.005 69.4721 322 69.6417 322 71C322 72.3583 322.006 72.5279 322.03 73.0613C322.055 73.5933 322.139 73.9563 322.262 74.275C322.39 74.6033 322.561 74.8829 322.839 75.1608C323.117 75.4383 323.396 75.6104 323.725 75.7375C324.044 75.8608 324.407 75.9454 324.939 75.97C325.472 75.995 325.642 76 327 76C328.358 76 328.528 75.9937 329.061 75.97C329.593 75.945 329.956 75.8608 330.275 75.7375C330.603 75.61 330.883 75.4383 331.161 75.1608C331.438 74.8829 331.61 74.6046 331.738 74.275C331.861 73.9563 331.945 73.5933 331.97 73.0613C331.995 72.5279 332 72.3583 332 71C332 69.6417 331.994 69.4721 331.97 68.9388C331.945 68.4067 331.861 68.0433 331.738 67.725C331.61 67.3962 331.438 67.1171 331.161 66.8392C330.883 66.5612 330.605 66.3896 330.275 66.2625C329.956 66.1388 329.593 66.0546 329.061 66.03C328.528 66.005 328.358 66 327 66ZM327 66.9002C328.334 66.9002 328.493 66.9069 329.02 66.9298C329.508 66.9527 329.773 67.0335 329.948 67.1027C330.183 67.1931 330.348 67.3014 330.524 67.476C330.699 67.651 330.807 67.8173 330.898 68.0514C330.966 68.2273 331.048 68.4919 331.07 68.9794C331.093 69.5069 331.099 69.6652 331.099 71.0002C331.099 72.3352 331.093 72.4939 331.068 73.021C331.043 73.5085 330.961 73.7731 330.893 73.9489C330.799 74.1831 330.693 74.3489 330.518 74.5248C330.343 74.6994 330.175 74.8077 329.943 74.8981C329.768 74.9664 329.499 75.0481 329.012 75.0702C328.481 75.0939 328.325 75.0994 326.987 75.0994C325.649 75.0994 325.493 75.0931 324.963 75.0685C324.475 75.0431 324.206 74.9619 324.031 74.8931C323.794 74.7998 323.631 74.6935 323.456 74.5185C323.281 74.3439 323.169 74.1752 323.081 73.9435C323.013 73.7685 322.932 73.4998 322.906 73.0123L322.905 72.9842C322.887 72.4811 322.881 72.3012 322.881 70.9939C322.881 69.688 322.887 69.5065 322.905 68.9989L322.906 68.9685C322.932 68.481 323.013 68.2127 323.081 68.0377C323.169 67.8002 323.281 67.6377 323.456 67.4623C323.631 67.2877 323.794 67.1752 324.031 67.0881C324.206 67.0189 324.469 66.9377 324.956 66.9127L324.98 66.9118C325.493 66.8938 325.664 66.8877 326.981 66.8877L327 66.9002ZM324.432 71.0001C324.432 69.5826 325.58 68.4326 326.999 68.4326C328.417 68.4326 329.567 69.5814 329.567 71.0001C329.567 72.4176 328.418 73.5676 326.999 73.5676C325.582 73.5676 324.432 72.4189 324.432 71.0001ZM327.001 72.6668C326.08 72.6668 325.334 71.921 325.334 71.0002C325.334 70.0793 326.08 69.3335 327.001 69.3335C327.921 69.3335 328.667 70.0793 328.667 71.0002C328.667 71.921 327.921 72.6668 327.001 72.6668ZM329.668 68.931C329.999 68.931 330.268 68.6623 330.268 68.331C330.268 68.0002 329.999 67.731 329.668 67.7314C329.338 67.7314 329.068 68.0002 329.068 68.331C329.068 68.6619 329.337 68.931 329.668 68.931Z",
    fill: "white",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 71,
    r: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.449 66.834H350.55C350.89 66.834 351.167 67.1027 351.167 67.4343V74.567C351.167 74.8989 350.89 75.1673 350.55 75.1673H343.449C343.109 75.1673 342.834 74.8989 342.834 74.567V67.4343C342.834 67.1027 343.109 66.834 343.449 66.834ZM343.971 68.6979C343.971 69.0934 344.29 69.4149 344.687 69.4149C345.083 69.4149 345.404 69.0934 345.404 68.6979C345.404 68.3027 345.083 67.9816 344.687 67.9816C344.29 67.9816 343.971 68.3027 343.971 68.6979ZM348.699 73.9351H349.933H349.933V71.7525C349.933 70.6813 349.702 69.8584 348.452 69.8584C347.85 69.8584 347.447 70.1883 347.281 70.5008H347.265V69.9587H346.08V73.9351H347.314V71.9674C347.314 71.4487 347.412 70.9469 348.056 70.9469C348.689 70.9469 348.699 71.5403 348.699 72.0015V73.9351ZM345.306 73.9354H344.068V69.959H345.306V73.9354Z",
    fill: "white",
    fillOpacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 71,
    r: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M310.314 69.3634C310.319 69.4374 310.319 69.5113 310.319 69.586C310.319 71.8607 308.599 74.4842 305.455 74.4842V74.4828C304.526 74.4842 303.616 74.2163 302.834 73.7111C302.969 73.7274 303.105 73.7356 303.241 73.7359C304.011 73.7366 304.759 73.4765 305.364 72.9976C304.633 72.9836 303.991 72.5033 303.767 71.8021C304.023 71.8519 304.287 71.8416 304.539 71.7724C303.741 71.6102 303.167 70.9045 303.167 70.085C303.167 70.0775 303.167 70.0704 303.167 70.0632C303.405 70.1965 303.671 70.2705 303.943 70.2787C303.192 69.7731 302.961 68.7668 303.414 67.9801C304.282 69.0556 305.563 69.7094 306.938 69.7786C306.8 69.1807 306.988 68.5541 307.432 68.1338C308.121 67.482 309.204 67.5154 309.851 68.2085C310.234 68.1324 310.601 67.991 310.937 67.7905C310.809 68.189 310.542 68.5275 310.186 68.7426C310.524 68.7024 310.856 68.611 311.167 68.4716C310.938 68.818 310.649 69.1196 310.314 69.3634Z",
    fill: "white",
    fillOpacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 71,
    r: 8,
    fill: "white",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M291.167 71.026C291.167 68.7109 289.302 66.834 287.001 66.834C284.7 66.834 282.834 68.7109 282.834 71.026C282.834 73.1185 284.358 74.8526 286.35 75.167V72.2378H285.292V71.0256H286.35V70.1027C286.35 69.0522 286.972 68.4717 287.924 68.4717C288.379 68.4717 288.856 68.5537 288.856 68.5537V69.5853H288.331C287.813 69.5853 287.651 69.9085 287.651 70.24V71.026H288.807L288.622 72.2382H287.651V75.1673C289.644 74.8526 291.167 73.1181 291.167 71.026Z",
    fill: "white",
    fillOpacity: 0.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 227,
    width: 270,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 235,
    width: 270,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 95.75,
    y: 243,
    width: 202.5,
    height: 4,
    rx: 2,
    fill: "white",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8516_255934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 32,
    fill: "white",
    transform: "translate(173 55)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageLayoutSocialAndCtaReach);
export default __webpack_public_path__ + "static/media/landingPageLayoutSocialAndCtaReach.5bd37508bf793fa380433bb29ae9ee26.svg";
export { ForwardRef as ReactComponent };